// TODO: I named this module Taxonomies, because in the long run it would be better
//       to group the shared and cutstom taxonomies in the same module

import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
    type: 'taxonomies',
    isLoading: false,
    shared: {},
    sharedSelectedId: undefined
    // custom: {} TODO: activate when merge custom taxonomies here
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
